// Section 5 — Freemium Tier Engine & Feature Gating. Pure client-side utility
// (Functional-First, matches the literal `middleware/tierGate.js` spec — placed under
// `lib/` to follow this codebase's existing convention alongside `lib/subscription.js`).
// Tier matrix, locked in per the subscription refactor: daily swipe recs now step
// Free 5 -> Plus 10 -> Pro 15 -> Elite unlimited (Pro is no longer unlimited).
// pdpReviewsUnlocked/pdpDetailedBreakdown/exactLocationTax gate the new PDP surfaces.
export const TIER_CONFIG = {
  FREE: { maxSourcesShown: 1, maxDailyDeckCards: 5, maxSavedVaultItems: 5, priceMonthly: 0.0, pdpReviewsUnlocked: false, pdpDetailedBreakdown: false, exactLocationTax: false },
  PLUS: { maxSourcesShown: 3, maxDailyDeckCards: 10, maxSavedVaultItems: 50, priceMonthly: 4.99, pdpReviewsUnlocked: false, pdpDetailedBreakdown: false, exactLocationTax: true },
  PRO: { maxSourcesShown: Infinity, maxDailyDeckCards: 15, maxSavedVaultItems: Infinity, priceMonthly: 9.99, pdpReviewsUnlocked: true, pdpDetailedBreakdown: true, exactLocationTax: true },
  ELITE: { maxSourcesShown: Infinity, maxDailyDeckCards: Infinity, maxSavedVaultItems: Infinity, priceMonthly: 19.99, pdpReviewsUnlocked: true, pdpDetailedBreakdown: true, exactLocationTax: true },
};

const _NEXT_TIER = { FREE: "PLUS", PLUS: "PRO", PRO: "PRO", ELITE: "ELITE" };

export function canViewPdpReviews(userTier) {
  const cfg = TIER_CONFIG[userTier] || TIER_CONFIG.FREE;
  if (cfg.pdpReviewsUnlocked) return { locked: false };
  return { locked: true, requiredTier: "PRO" };
}

export function canViewExtraSources(userTier, requestedIndex) {
  const cfg = TIER_CONFIG[userTier] || TIER_CONFIG.FREE;
  if (requestedIndex < cfg.maxSourcesShown) return { locked: false };
  return { locked: true, requiredTier: _NEXT_TIER[userTier] || "PLUS" };
}

export function canSaveCard(userTier, currentSavedCount) {
  const cfg = TIER_CONFIG[userTier] || TIER_CONFIG.FREE;
  if (currentSavedCount < cfg.maxSavedVaultItems) return { locked: false };
  return { locked: true, requiredTier: _NEXT_TIER[userTier] || "PLUS" };
}

export function canViewDailyDeckCard(userTier, cardIndex) {
  const cfg = TIER_CONFIG[userTier] || TIER_CONFIG.FREE;
  if (cardIndex < cfg.maxDailyDeckCards) return { locked: false };
  return { locked: true, requiredTier: _NEXT_TIER[userTier] || "PLUS" };
}

// Maps this app's backend plan keys (free/plus/pro/gold) onto the 4 display tiers
// used throughout the gating UI. Deliberately plan-based only (no is_admin override)
// so admin/dev accounts can genuinely experience each tier via upgrade-sim.
export function planToTier(plan) {
  return { free: "FREE", plus: "PLUS", pro: "PRO", gold: "ELITE" }[plan] || "FREE";
}
